import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import UserUnisatallSurvey from './uninstallSurvey'

class UnisatallSurvey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems : [
                { title : "Minimis", link : "/" },
                { title : "Uninstall Survey", link : "#" },
            ],
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                               <UserUnisatallSurvey/>
                        </Row>

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default UnisatallSurvey;
